import { jsx as _jsx } from "react/jsx-runtime";
import { StatusIcons } from '../../Iconography';
export const present = (p) => (p.value ? _jsx(StatusIcons.Success, { color: "success" }) : _jsx("div", {}));
export const trueIsGood = (p) => (p.value ? _jsx(StatusIcons.Success, { color: "success" }) : _jsx(StatusIcons.Failed, { color: "error" }));
